import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, [
  /*#__PURE__*/_createTextVNode(" Upload a CSV file with columns: "),
  /*#__PURE__*/_createElementVNode("strong", null, "Name, Phone, Email, ID Number"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Rows where Phone / Email / ID Number already exist will be skipped. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop CSV here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to browse")
], -1)
const _hoisted_4 = {
  key: 1,
  class: "py-2"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-start"
}
const _hoisted_6 = { class: "fw-bold text-warning mb-1" }
const _hoisted_7 = {
  class: "ps-4",
  style: {"max-height":"150px","overflow-y":"auto"}
}
const _hoisted_8 = {
  key: 1,
  class: "mt-2 text-start"
}
const _hoisted_9 = { class: "fw-bold text-danger mb-1" }
const _hoisted_10 = {
  class: "ps-4",
  style: {"max-height":"150px","overflow-y":"auto"}
}

import { ref } from "vue";
import { UploadFilled } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";
import ToolServices from "../services/ToolServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockListImport',
  emits: ["imported"],
  setup(__props, { expose: __expose, emit: emits }) {



const visible = ref(false);
const isImporting = ref(false);
const selectedFile = ref<File | null>(null);
const result = ref<any>(null);
const uploadRef = ref<any>(null);

const show = () => {
  selectedFile.value = null;
  result.value = null;
  visible.value = true;
};

const onFileChange = (file: any) => {
  selectedFile.value = file.raw;
};

const onFileRemove = () => {
  selectedFile.value = null;
};

const doImport = async () => {
  if (!selectedFile.value) return;
  isImporting.value = true;
  try {
    result.value = await ToolServices.importBlockedList(selectedFile.value);
    if (result.value.imported > 0) emits("imported");
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Import failed.",
      offset: 100,
    });
  }
  isImporting.value = false;
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "Import Blocked List",
    width: "440px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      (!result.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: isImporting.value,
              disabled: !selectedFile.value,
              onClick: doImport
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Import ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ], 64))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
            ]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      (!result.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": false,
              limit: 1,
              accept: ".csv",
              "on-change": onFileChange,
              "on-remove": onFileRemove,
              drag: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UploadFilled))
                  ]),
                  _: 1
                }),
                _hoisted_3
              ]),
              _: 1
            }, 512)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_result, {
              icon: result.value.errors?.length ? 'warning' : 'success',
              title: 
          result.value.errors?.length
            ? 'Import completed with warnings'
            : result.value.duplicates?.length
            ? 'Import completed with duplicates'
            : 'Import successful'
        
            }, {
              "sub-title": _withCtx(() => [
                _createElementVNode("p", null, [
                  _createTextVNode(" Imported: "),
                  _createElementVNode("strong", null, _toDisplayString(result.value.imported), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Skipped (duplicates): "),
                  _createElementVNode("strong", null, _toDisplayString(result.value.duplicates?.length ?? 0), 1)
                ]),
                (result.value.duplicates?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, " Duplicates (" + _toDisplayString(result.value.duplicates.length) + "): ", 1),
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value.duplicates, (d, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: i,
                            class: "text-warning small"
                          }, _toDisplayString(d.name) + " — " + _toDisplayString(d.email || d.phone || d.idNumber), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (result.value.errors?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, " Errors (" + _toDisplayString(result.value.errors.length) + "): ", 1),
                      _createElementVNode("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value.errors, (err, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: i,
                            class: "text-danger small"
                          }, _toDisplayString(err), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["icon", "title"])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})